import { Address, Country, Organization, OrganizationType } from 'src/types'

export type DrawerOrganizationForm = Pick<
  Organization,
  | 'code'
  | 'legal_name'
  | 'organization_id'
  | 'organization_type'
  | 'trade_name'
  | 'user_limit'
  | 'vat_number'
> &
  Pick<
    Address,
    | 'address_number'
    | 'address'
    | 'city_id'
    | 'city'
    | 'country_id'
    | 'country'
    | 'description'
    | 'state_id'
    | 'state'
  > & {
    email: string
    phone_contact: string
  }

const defaultCountry: Country = {
  abbreviation: 'BR',
  calling_code: '55',
  country_id: 29,
  iso: 'BRA',
  name: 'Brazil',
  reference_currency_id: 21
}

export const initialDrawerValues: DrawerOrganizationForm = {
  address_number: '',
  address: '',
  city_id: '',
  city: null,
  code: '',
  country_id: defaultCountry.country_id.toString(),
  country: defaultCountry,
  description: '',
  email: '',
  legal_name: '',
  organization_id: Math.random().toString(),
  organization_type: OrganizationType.HOLDING,
  phone_contact: '',
  state_id: '',
  state: null,
  trade_name: '',
  user_limit: 100,
  vat_number: ''
}

export const emptyDrawerValues: any = {}

export type PartialTenant = {
  organizations: Organization[]
  tenant_id: string
  tenant_organization_name: string
  tenant_sufix: string
}

export const initialTenantValues: PartialTenant = {
  organizations: [],
  tenant_id: Math.random().toString(),
  tenant_organization_name: '',
  tenant_sufix: ''
}
